import type { OnInit } from '@angular/core';
import {
  ChangeDetectionStrategy,
  Component,
  ErrorHandler,
  inject,
} from '@angular/core';
import { SITE_NAME } from '@freelancer/config';
import { Pwa } from '@freelancer/pwa';
import { ModalService } from '@freelancer/ui';
import { ButtonColor } from '@freelancer/ui/button';
import { ButtonComponent } from '../../button/button.component';

@Component({
  standalone: true,
  template: `
    <div class="MainBody">
      <h2
        class="text-large mb-xsmall"
        i18n="Native App Update Required Main Body Title"
      >
        Update Required
      </h2>
      <div>
        <p
          class="mb-small"
          i18n="Native Update Required Message"
        >
          A new version of the {{ siteName }} app is available. Please update
          through the {{ storeType }} now.
        </p>
      </div>
    </div>
    <div class="ActionContainer">
      <fl-button
        class="ActionButton"
        i18n="Native Update Required Update Button"
        link="/download"
        [color]="ButtonColor.SECONDARY"
      >
        Update
      </fl-button>
    </div>
  `,
  styleUrls: ['./update-native-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent],
})
export class UpdateNativeModalComponent implements OnInit {
  private pwa = inject(Pwa);
  private modalService = inject(ModalService);
  private errorHandler = inject(ErrorHandler);
  siteName = inject(SITE_NAME);

  ButtonColor = ButtonColor;
  storeType: string;

  ngOnInit(): void {
    if (this.pwa.isNative()) {
      const platform = this.pwa.getPlatform();
      if (platform === 'ios') {
        this.storeType = 'App Store';
      } else if (platform === 'android') {
        this.storeType = 'Play Store';
      }
    } else {
      // Do not show update prompt outside of native app.
      this.errorHandler.handleError(
        new Error('Attempted to open UpdateNativeModal outside of native app'),
      );
      this.modalService.close();
    }
  }
}
